import {
  FormBody,
  FormFieldsContainer,
  FormInlineNotifications,
  useFormValidationErrorsNotification,
} from '../../../../../../Form'
import { useRentalPortalProfileBlockFormActions } from '../../../../../RentalPortal.hooks'

import { ApplicantIdentityEmailField } from './ApplicantIdentityEmailField'
import { ApplicantIdentityNameField } from './ApplicantIdentityNameField'
import { ApplicantIdentityPhoneField } from './ApplicantIdentityPhoneField'

import * as styles from './ApplicantIdentityWidgetFormFields.module.css'

function ApplicantIdentityWidgetFormFields({
  isCloseConfirm,
  notifications,
  onCancel,
  onRemoveNotification,
  onSetNotification,
}) {
  const { actionsProps } = useRentalPortalProfileBlockFormActions({
    isCloseConfirm,
    onCancel,
  })

  useFormValidationErrorsNotification({
    onRemoveNotification,
    onSetNotification,
  })

  return (
    <FormBody
      actionsProps={actionsProps}
      className={styles.ApplicantIdentityWidgetFormFields}
    >
      <FormInlineNotifications notifications={notifications} />
      <FormFieldsContainer className={styles.fields}>
        <ApplicantIdentityNameField />
        <ApplicantIdentityEmailField />
        <ApplicantIdentityPhoneField />
      </FormFieldsContainer>
    </FormBody>
  )
}

export default ApplicantIdentityWidgetFormFields
